import PruebasList from "../components/PruebasList";

// ✅ Componente con nombre para evitar la advertencia ESLint
const SimulacrosPage = () => (
  <section className="container mx-auto px-4 py-8">
    <h1 className="text-2xl font-bold">Simulacros</h1>

    {/* Texto explicativo */}
    <p className="text-gray-600 mb-6">
      Practica en condiciones reales de examen: 30 preguntas, tiempo de 2 horas y
      un reporte inmediato de tu puntaje. Selecciona un simulacro para medir tu
      progreso y descubrir en qué temas necesitas reforzar.
    </p>

    <PruebasList tipo="simulacro" />
  </section>
);

// ✅ Exporta el componente ya nombrado
export default SimulacrosPage;
